<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "Olympics"
    }
</script>

<style scoped>

</style>
